import {
    getExecution,
    listExecutions
} from './queries';
import {cancelExecution, executePlaybook} from './mutations';

import {GraphQLQuery,} from '@aws-amplify/api';

import {
    CancelExecution,
    CancelExecutionInput,
    ExecutePlaybook,
    ExecutePlaybookInput,
    GetExecution,
    ListExecutions,
} from "../types.ts";
import {workflowsApiClient} from "../../workflows-api-integration/client.ts";


const client = workflowsApiClient;

// Returns the page ENVELOPE, not a bare array. The caller is an infinite query
// and needs `nextToken` to ask for the next page; returning only `items`
// discards it, which is what kept this list to a single unpaginated page.
export const fetchRecords = async (query: {
    filter?: object;
    limit?: number;
    nextToken?: string | null;
}) => {
    const {filter, limit, nextToken} = query;
    const response = await client.graphql<GraphQLQuery<ListExecutions>>({
                                                                            query: listExecutions,
                                                                            variables: {filter, limit, nextToken},
                                                                        });
    return {
        items: response.data?.listExecutions.items ?? [],
        nextToken: response.data?.listExecutions.nextToken ?? null,
    };
};

export const fetch = async (id: string) => {
    const response = await client.graphql<GraphQLQuery<GetExecution>>({
                                                                          query: getExecution,
                                                                          variables: {id: id},
                                                                      });
    return response.data?.getExecution;
};

export const start = async (input: ExecutePlaybookInput) => {
    const response = await client.graphql<GraphQLQuery<ExecutePlaybook>>({
                                                                             query: executePlaybook,
                                                                             variables: {input},
                                                                         });
    return response.data?.executePlaybook;
};

export const cancel = async (input: CancelExecutionInput) => {
    const response = await client.graphql<GraphQLQuery<CancelExecution>>({
                                                                             query: cancelExecution,
                                                                             variables: {input},
                                                                         });
    return response.data?.cancelExecution;
};
